// Client layer (TS-2.5.03). Purely a renderer over lib/legend.ts's data-driven entries - see that
// module for why the set and the order are both sourced from data rather than a literal.
import type { CSSProperties } from "react";
import { resolveColor } from "./lib/colorTokens";
import type { LegendEntry } from "./lib/legend";
import { strings } from "../../strings";

export interface LegendProps {
  readonly entries: readonly LegendEntry[];
}

export function Legend({ entries }: LegendProps) {
  return (
    <ul className="eg-legend" aria-label={strings.roadmap.aria.statusLegend}>
      {entries.map((entry) => (
        <li key={entry.label} className="eg-legend__item">
          {/* The custom property lets roadmap.css derive an ink-mixed rim from the swatch's own
              colour, so light swatches (gray, gold) hold a >= 3:1 boundary on the page (D-247). */}
          <span
            className="eg-legend__swatch"
            aria-hidden="true"
            style={{ "--eg-swatch-color": resolveColor(entry.colorHex) } as CSSProperties}
          />
          {entry.label}
        </li>
      ))}
    </ul>
  );
}
